import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import { DatePicker } from '@material-ui/pickers'
import moment from 'moment'

export default function HotSwapDatePicker({ onDateChange, disableWeeks }) {
    const { locale } = useSelector(state => state.main)
    const classes = useStyles()

    const today = moment()
    const tomorrow = moment().add(1, 'days')
    const tomorrowPlusOne = moment().add(2, 'days')
    const tomorrowPlusTwo = moment().add(3, 'days')
    const comparisonFormat = 'YYYY-MM-DD'
    const additionalBlockDatesArr = [
        today,
        tomorrow,
        tomorrowPlusOne,
        tomorrowPlusTwo
    ]

    useEffect(() => {
        let initDate = moment().add(1, 'days')
        initDate = findNextAvailableDate(initDate)
        if (initDate) {
            onDateChange(initDate.format('YYYY-MM-DD'))
        }
    }, [])

    const handleDateChange = value => {
        if (!value.isSame(moment(), 'day')) {
            onDateChange(value.format('YYYY-MM-DD'))
        }
    }

    const disableDates = date => {
        if (!disableWeeks) {
            return false
        }

        for (let i = 0; i < additionalBlockDatesArr.length; i++) {
            const comparisonDate = additionalBlockDatesArr[i]
            if (
                comparisonDate.format(comparisonFormat) ===
                date.format(comparisonFormat)
            ) {
                return true
            }
        }

        const startDate = new Date(date.year(), 0, 1)

        var days = Math.floor((date - startDate) / (24 * 60 * 60 * 1000))
        var weekNumber = Math.ceil(days / 7)

        return !disableWeeks.find(
            disableWeek =>
                disableWeek.week === weekNumber &&
                disableWeek.year === date.year()
        )?.is_available_capacity
    }

    const findNextAvailableDate = initialDate => {
        let date = initialDate.clone()
        const MAX_DAYS_TO_CHECK = 50
        for (let i = 0; i < MAX_DAYS_TO_CHECK; i++) {
            if (!disableDates(date)) {
                return date
            }
            date.add(1, 'days')
        }
        return null
    }

    return (
        <div className={classes.container}>
            <DatePicker
                open={true}
                variant="static"
                disableToolbar
                autoOk
                disablePast
                label={locale.reports.filterTo}
                format="DD/MM/YYYY"
                onChange={handleDateChange}
                shouldDisableDate={disableDates}
            />
        </div>
    )
}

const useStyles = makeStyles(() => ({
    container: {
        background: '#fff',
        borderRadius: 8,
        border: '1px solid #F2F4F7',
        padding: 3,
        display: 'flex',
        justifyContent: 'center',
        boxShadow:
            '0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)'
    }
}))
